import { useState, useEffect } from "react"

const Toggle = ({ defaultChecked, onChange }) => {
  const isControlled = typeof defaultChecked === 'boolean';
  const [isChecked, setIsChecked] = useState(defaultChecked);

  useEffect(() => {
    if (!isControlled) {
      setIsChecked(defaultChecked);
    }
  }, [defaultChecked, isControlled]);

  const actualChecked = isControlled ? defaultChecked : isChecked;

  const handleToggle = () => {
    const newValue = !actualChecked;
    if (!isControlled) {
      setIsChecked(newValue);
    }
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <button
      type="button"
      className={`relative inline-flex h-[22px] w-[44px] items-center rounded-full transition-colors duration-200 focus:outline-none ${
        actualChecked ? "bg-[#22C55E]" : "bg-gray-200"
      }`}
      role="switch"
      aria-checked={actualChecked}
      onClick={handleToggle}
    >
      <span
        className={`inline-block h-[18px] w-[18px] transform rounded-full bg-white shadow-sm transition-transform duration-200 ease-in-out ${
          actualChecked ? "translate-x-[24px]" : "translate-x-[2px]"
        }`}
      />
    </button>
  );
};

export default function TogglePage({ defaultChecked, setRestaurantStatus }) {
  const [state, setState] = useState(defaultChecked || false)

  useEffect(() => {
    if (setRestaurantStatus) setRestaurantStatus(state);
  }, [state, setRestaurantStatus]);

  return (
    <div className="flex items-center">
      <Toggle defaultChecked={state} onChange={setState} />
    </div>
  )
}
